module.exports = __webpack_public_path__ + "img/1318.d5b6fdee.gif";